import { type FC } from "react";
import * as styles from "./styles.css";

// 削除予定のコンポーネントです。
// デザイン上の理由がない場合、
// app/packs/shared/components/Tableディレクトリ直下のものを使用してください。

type Props = {
  /** trの内容 */
  children?: React.ReactNode;
  /** コンポーネントに適用するクラス名 */
  className?: string;
};

export const Tr: FC<Props> = ({ children, className }) => (
  <tr
    className={`
      ${styles.tr}
      ${className || ""}
    `}
  >
    {children}
  </tr>
);
